/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Warehouse_Awaiting_Stock_OutInputs */

const vi_dashboard_warehouse_awaiting_stock_out = /** @type {(inputs: Dashboard_Warehouse_Awaiting_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn chờ xuất kho`)
};

/**

* @param {Dashboard_Warehouse_Awaiting_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_warehouse_awaiting_stock_out = /** @type {((inputs?: Dashboard_Warehouse_Awaiting_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Warehouse_Awaiting_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_warehouse_awaiting_stock_out(inputs)
});